import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const isPublicRegistrationRoute = () => window.location.pathname.startsWith("/pessoas/");

const installSafeDomMutationGuard = () => {
  if (window.__safeDomMutationGuardInstalled || typeof Node === "undefined") return;
  window.__safeDomMutationGuardInstalled = true;

  const originalRemoveChild = Node.prototype.removeChild;
  const originalInsertBefore = Node.prototype.insertBefore;

  Node.prototype.removeChild = function patchedRemoveChild(child) {
    if (isPublicRegistrationRoute() && child && child.parentNode !== this) {
      window.__lastDomMutationGuard = {
        type: "removeChild_parent_mismatch",
        path: window.location.pathname,
        at: new Date().toISOString(),
      };
      return child;
    }
    return originalRemoveChild.call(this, child);
  };

  Node.prototype.insertBefore = function patchedInsertBefore(newNode, referenceNode) {
    if (isPublicRegistrationRoute() && referenceNode && referenceNode.parentNode !== this) {
      window.__lastDomMutationGuard = {
        type: "insertBefore_reference_mismatch",
        path: window.location.pathname,
        at: new Date().toISOString(),
      };
      return this.appendChild(newNode);
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
};

installSafeDomMutationGuard();

const resizeObserverMessage = "ResizeObserver loop completed with undelivered notifications";
window.addEventListener("error", (event) => {
  if (event.message === resizeObserverMessage) {
    event.stopImmediatePropagation();
  }
});
window.addEventListener("unhandledrejection", (event) => {
  if (String(event.reason || "").includes(resizeObserverMessage)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
